import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import {
    IElementNode,
    ISlideNode,
    ITextParagraphBoxNode,
} from '../../slide-content-enumerator/enumerator-types.interface';
import { ContentTree } from '../../slide-content-layout-analyzer/core/algorithm/data-structure/content-tree';
import { VipsContentLayoutAnalyzer } from '../../slide-content-layout-analyzer/core/algorithm/vips-content-analyzer';
import { BaseAnalyzer } from '../base/base-analyzer';

export class MachineContentLayoutAnalyzer extends BaseAnalyzer<ContentTree[]> {
    private contentLayoutAnalyzer: VipsContentLayoutAnalyzer; // vips算法布局信息检测

    public constructor(private uiDataService: IUiDataService) {
        super();
        this.contentLayoutAnalyzer = new VipsContentLayoutAnalyzer();
    }

    public onPresentationStart(): void {
        this.contentLayoutAnalyzer.resetWithPresentation(this.uiDataService.presentation);
    }

    public onSlideStart(slide: ISlideNode): void {
        this.contentLayoutAnalyzer.analysisNewSlide(slide.slide, slide.slideIndex);
    }

    public onSlideEnd(slide: ISlideNode): void {
        this.contentLayoutAnalyzer.analysisSlideEnd(slide.slide, slide.slideIndex);
    }

    public onElement(element: IElementNode): void {
        this.contentLayoutAnalyzer.analysisElement(element, { noAnalysisShape: true });
    }

    public onParagraphParentBox(textParagraphBoxNode: ITextParagraphBoxNode): void {
        this.contentLayoutAnalyzer.analysisTextParagraph(textParagraphBoxNode);
    }

    public async calculateResult(): Promise<ContentTree[]> {
        return this.contentLayoutAnalyzer.contentTreeList;
    }
}
